import 'bootstrap.collapse';
import 'configure-default-runtime';
import 'fancybox';
import 'bootstrap.modal';
import 'global';
import { onLoad } from 'runtime';
import '/assets/theme/js/mmenu-light.js?v=2';

// Add class sticky to menu on scroll.
const header = document.getElementById('header');

window.addEventListener('scroll', () => {
    if (window.scrollY >= 50)
        header.classList.add('sticky-styles');
    else
        header.classList.remove('sticky-styles');
});

// Mobile Menu
const menu = new MmenuLight(document.querySelector('#menu-navbar'), '(max-width: 991px)');

menu.navigation({
    slidingSubmenus: true,
    title: 'Menu'
});

const drawer = menu.offcanvas({
    position: 'left'
});

// Open the menu.
document.querySelector('button[href="#menu-navbar"]')
    .addEventListener('click', e => {
        e.preventDefault();
        drawer.open();
    });

onLoad(context => {
    //Services - home
    const questions = context.querySelectorAll('.services-home .questions .question');
    const images = context.querySelectorAll('.services-home .image img');

    questions.forEach((question, index) => {
        const collapseEl = question.querySelector('.collapse');

        // Listen for when this question is shown
        collapseEl.addEventListener('shown.bs.collapse', () => {
            // Remove 'active' from all images
            images.forEach(img => img.classList.remove('active'));

            // Add 'active' to the image that corresponds to this question
            if (images[index]) {
                images[index].classList.add('active');
            }
        });
    });

    scrollRevealOnScroll(context, '.scroll-reveal', 'fade-in-up');
    scrollRevealOnScroll(context, '.scroll-reveal-scale', 'fade-in-scale');
    scrollRevealOnScroll(context, '.scroll-reveal-left', 'fade-in-left');
    scrollRevealOnScroll(context, '.scroll-reveal-right', 'fade-in-right');

    // Scroll To
    context.querySelectorAll('.scroll-to').forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            var href = link.getAttribute('href'); // Use 'link' instead of 'this'.
            var target = context.querySelector(href);

            // Calculate the offsetTop including the offset of all parent elements.
            var offsetTop = target.offsetTop;
            var currentElement = target;
            while (currentElement.offsetParent !== null) {
                currentElement = currentElement.offsetParent;
                offsetTop += currentElement.offsetTop;
            }
            window.scroll({
                top: offsetTop - 120,
                behavior: 'smooth'
            });
        });
    });
});

// Scroll reveal styles
function scrollRevealOnScroll(context, revealSelector, animationClass) {
    var elements = context.querySelectorAll(revealSelector);

    if (elements.length === 0) return;

    window.addEventListener('scroll', function() {
        elements.forEach(function(element) {
            var positionFromTop = element.getBoundingClientRect().top;
            if (positionFromTop <= window.innerHeight && positionFromTop >= 0) {
                element.classList.add(animationClass);
            }
        });
    });
}